import { Link, useLocation } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import { categories } from "@/mocks/site";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Seo
        title="页面走丢了 - 蝌蚪爆料"
        description="你访问的页面不存在或已被调整，回到蝌蚪爆料首页继续查看正在追踪的热点事件。"
        path="/"
      />
      <section className="flex flex-col items-center justify-center px-4 py-24 text-center md:py-32">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-compass-3-line text-3xl" aria-hidden="true"></i>
        </span>
        <p className="mt-6 font-heading text-5xl font-bold text-foreground-200 md:text-6xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面暂时找不到
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          它可能已经被合并到其他事件，或者链接输入有误。你可以回到首页，
          或从下面的栏目继续浏览。
        </p>
        <p className="mt-3 font-label-role text-xs text-foreground-400">{location.pathname}</p>

        <Link
          to="/"
          className="mt-8 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {categories.map((item) => (
            <Link
              key={item.slug}
              to={`/category/${item.slug}`}
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className={`${item.icon} text-sm`} aria-hidden="true"></i>
              {item.name}
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}